import React from 'react'
import { TableRow, TableCell, IconButton } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { palette } from 'styles/colors'
import editIcon from 'assets/edit.png'
import deleteIcon from 'assets/delete.png'

const Works = ({
  classes,
  works,
  openEditWork,
  openDelete
}) => {
  let type = ''

  return works.map((work, index) => (
    <TableRow key={index} className={classes.wrapper}>
      <TableCell
        style={{ width: '100px', borderColor: palette.black }}
        align="center"
      >
        {work.placeOfWork}
      </TableCell>
      <TableCell
        style={{ width: '100px', borderColor: palette.black }}
        align="center"
      >
        {work.position}
      </TableCell>
      <TableCell
        style={{ width: '100px', borderColor: palette.black }}
        align="center"
      >
        {work.startDate.replace(/-/g, '.')}
      </TableCell>
      <TableCell
        style={{ width: '80px', borderColor: palette.black }}
        align="center"
      >
        {work.endDate.replace(/-/g, '.')}
      </TableCell>
      <TableCell
        style={{ width: '20px', borderColor: palette.black }}
        align="center"
      >
        <IconButton
          onClick={() =>
            openEditWork({ ...work }, index, type = 'workExperience')
          }
        >
          <img src={editIcon} alt="edit" width="15" />
        </IconButton>
      </TableCell>
      <TableCell
        style={{ width: '20px', borderColor: palette.black }}
        align="center"
      >
        <IconButton
          onClick={() => {
            openDelete(index, type = 'workExperience')
          }}
        >
          <img src={deleteIcon} alt="delete" width="15" />
        </IconButton>
      </TableCell>
    </TableRow>
  ))
}
const styles = () => ({
  wrapper: {
    height: '40px'
  }
})

export default withStyles(styles)(Works)